import { useContext } from "react";
import { Button, Col, Space } from "antd";
import classNames from "classnames";
import { Sticky_Delta_Strike_LABELS } from "constants/generalActionButtons";
import { VOL_SURFACE_STICKY_DELTA_OR_STRIKE } from "constants/volSurface";
import { GlobalContext } from "contexts/GlobalContext";
import { setDataToLocalStorage } from "helpers/generalHelper";
import { VolSurfaceContext } from "contexts/VolSurfaceContext";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";

function StickyDeltaOrStrickTabs({ currentTab, setCurrentTab }) {
  const {
    globalState: { dark_Theme, loginInfo },
  } = useContext(GlobalContext);
  const { setVolSurfaceFilterShortcuts } = useContext(VolSurfaceContext);
  const { setIsCalculationDateChanged, setLockedData, setStickyStrikeData } =
    useVolSurfaceControlTable();

  function onClickHandle(item) {
    if (item === currentTab) return;
    setVolSurfaceFilterShortcuts(null);
    setCurrentTab(item);
    setDataToLocalStorage(VOL_SURFACE_STICKY_DELTA_OR_STRIKE, item);
    setIsCalculationDateChanged(0);
    setLockedData(null);
    setStickyStrikeData(null);
  }

  return (
    <Col span={24}>
      <Space>
        {Object.values(Sticky_Delta_Strike_LABELS)
          .filter(
            (item) =>
              (item.key === Sticky_Delta_Strike_LABELS.STICKY_DELTA.key &&
                loginInfo?.authorized_permissions?.includes(
                  "view-vol-surface-marks"
                )) ||
              (item.key === Sticky_Delta_Strike_LABELS.STICKY_STRIKE.key &&
                loginInfo?.authorized_permissions?.includes(
                  "view-vol-surface-sticky-strike"
                ))
          )
          .map((item, index) => {
            return (
              <Button
                style={{ marginBottom: "10px" }}
                className={classNames({
                  "ant-btn-dark": dark_Theme,
                  "selected-button":
                    item.key === currentTab,
                })}
                key={item.key + index}
                onClick={() => onClickHandle(item.key)}
              >
                {item.label}
              </Button>
            );
          })}
      </Space>
    </Col>
  );
}

export default StickyDeltaOrStrickTabs;
